import { baseUrl } from "@/requestConfig/baseUrl";
import axios from "@/requestConfig/intercept";
import { Response } from "../index.limit";
import { ReqBindCustomerList, ReqCustomerBind, ReqCustomerList, ReqZtInfoes, ResBindCustomerList, ResCustomerList, ResZtInfoes } from "./index.limit";
export * from "./index.limit";

const { api } = baseUrl;
/**
 * 获取可见客户列表
 * @returns
 */
export const apiCustomerlist = async (params: ReqCustomerList): Promise<Response<ResCustomerList[]>> => {
  return axios.get(`${api}/customer/customerlist`, { params });
};
/**
 * 获取当前外部联系人绑定的客户集合
 * @returns
 */
export const apiBindcustomerlist = (params: ReqBindCustomerList): Promise<Response<ResBindCustomerList[]>> => {
  return axios.get(`${api}/customer/bindcustomerlist`, { params });
};

/**
 * 企业成员关联客户
 * @returns
 */
export const apiCustomerBind = (data: ReqCustomerBind): Promise<Response<string>> => {
  return axios.post(`${api}/customer/customerbind`, data);
};

/**
 * 获取账套信息
 */
export const apiZtInfoes = (params: ReqZtInfoes): Promise<Response<ResZtInfoes[]>> => {
  return axios.get(`${api}/Financial/ZtInfoes`, { params });
};
